export default "__VITE_ASSET__71261fa3__"